import { createRoute } from '@tanstack/react-router';

import { menuLayoutRoute } from 'root/MenuLayout';
import RequireSingleCountry from 'root/RequireSingleCountry';

import { OverrideManagementView } from './OverridesView/OverrideManagementView';
import { overridesRouteSearchSchema } from './search';

const overrideManagementMainRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  path: 'override-management',
  component: RequireSingleCountry,
});

const overrideManagementRoute = createRoute({
  getParentRoute: () => overrideManagementMainRoute,
  component: OverrideManagementView,
  path: '/',
  validateSearch: overridesRouteSearchSchema,
});

export const overrideManagementRouteTree = overrideManagementMainRoute.addChildren({
  overrideManagementRoute,
});
